import {
	ModalOnboarding,
	ModalOnboardingProps,
} from "#components/modal-onboarding/modal-onboarding";
import React from "react";
import { useTranslation } from "react-i18next";

import bannerImg from "./banner.png";

type BonusReportModalProps = Pick<ModalOnboardingProps, "onClose">;

export const BonusReportModal = ({ onClose }: BonusReportModalProps) => {
	const { t } = useTranslation("components", {
		keyPrefix: "notifications.onboarding.bonusReport",
	});

	return (
		<ModalOnboarding
			bannerSrc={bannerImg}
			title={t("title")}
			content={t("content")}
			onClose={onClose}
			width={756}
			actions={{
				primary: {
					label: t("primaryActionLabel"),
					buttonProps: {
						trailingIcon: null,
					},
				},
			}}
		/>
	);
};
